import React from 'react'

import AddZoneForm from '../../modules/Zone/components/AddZoneForm'
export default function AddZonePage() {
  return <AddZoneForm />
}
